<template>
  <div>
    <div v-if="showKwiky" class="overlay">
      <b-modal ref="image-modal" id="image-modal" hide-footer title="Product image">
        <div class="d-block text-center">
          <b-img :src="productImage" fluid alt="No image"></b-img>
        </div>
        <b-button class="mt-3" variant="outline-danger" block @click="$bvModal.hide('image-modal')">Close</b-button>
      </b-modal>
      <div class="kwiky-products-box w-75">
        <div class="w-full mb-2">
          <b-button @click="orderingDone" class="btn-warning">CLOSE <b-icon-x></b-icon-x></b-button>
          <h3 class="text-white ml-3 d-inline-block align-middle">{{selectedRefArticle.name}}</h3>
        </div>
        <table class="table">
          <thead>
          <tr>
            <th scope="col">SKU</th>
            <th scope="col">Name</th>
            <th scope="col">Manufacturer</th>
            <th scope="col">NOK</th>
            <th scope="col">Image</th>
            <th scope="col">Order</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="kp in kwikyProducts" :key="kp.codename">
            <th scope="row"><a class="text-white" :href="kp.URL" target="_blank" rel="noopener noreferrer">{{kp.codename}}</a></th>
            <th scope="row">{{kp.name}}</th>
            <td>{{manufacturerFromCodes(kp.productCodes.productCode)}}</td>
            <td>{{kp.productPrices.product_price.price.amount_with_vat || 'No price'}}</td>
            <td>
              <b-button  v-if="kp.images && kp.images.image && kp.images.image.length" @click="showProductImage(kp.images.image[0].url)">
                <b-icon-image></b-icon-image>
              </b-button>
              <span v-else>No image</span>
            </td>
            <td>
              <b-button @click="orderKwikyArticle(kp.codename, kp.name)">
                <b-icon-download></b-icon-download>
              </b-button>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  <div v-else class="container">
    <div class="row">
      <div class="w-100 text-center mt-3">
        <h3>REF LAGER ORDERING</h3>
      </div>
    </div>
    <div class="row">
      <div class="w-100 mt-3">
        <div class="text-center" v-if="loading">
          <b-icon icon="arrow-clockwise" animation="spin" font-scale="3"></b-icon>
        </div>
        <table v-else-if="!loading && products.length" class="table">
          <thead>
          <tr>
            <th class="d-none d-sm-table-cell">Ref Stock ID</th>
            <th class="d-none d-sm-table-cell">Manufacturer</th>
            <!--            <th class="d-none d-sm-table-cell">Fac. number</th>-->
            <th class="d-sm-table-cell">Name</th>
            <th class="d-sm-table-cell">Number</th>
            <th>Price</th>
            <th>Delete</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="product in products" :key="product.refStock.articleId">
            <td>
              <a :href="`https://catalog.meca.no/ProductSheet.aspx?Article_ID=${product.refStock.articleId}&CarReference_ID=-1&CategoryType_ID=0`" target="_blank" rel="noopener noreferrer">
                {{product.refStock.articleId || '0'}}
              </a>
            </td>
            <td class="d-none d-sm-table-cell">
              {{product.refStock.manufacturer || 'No manufacturer'}}
            </td>
            <td @click="getKwikyFromSKUList(product.kwikySKUs, product.refStock)" class="pointer">{{product.refStock.name || 'no name'}}</td>
            <td>{{product.refStock.number || 'no number'}}</td>
            <td>{{product.refStock.price || '0'}}</td>
            <td>
              <b-button @click="deleteRefStockArticle(product.refStock.articleId)"><b-icon-trash></b-icon-trash></b-button>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div v-if="!loading" class="row mb-3" style="font-size: 30px">
      <div class="w-50">
        <span v-if="page > 0" @click="prevPage()" class="pointer">
          <b-icon-caret-left></b-icon-caret-left>{{page}}
        </span>
      </div>
      <div class="w-50">
        <span v-if="products.length" @click="nextPage()" class="float-right pointer">{{page+2}}
          <b-icon-caret-right></b-icon-caret-right>
        </span>
      </div>
    </div>
  </div>
  </div>
</template>
<script>
import axios from 'axios';
import fixed from '@/fixed';

export default {
  data: () => ({
    loading: false,
    page: 0,
    products: [],
    kwikyProducts: [],
    productImage: '',
    showKwiky: false,
    selectedRefArticle: {
      id: null,
      ordered: false,
      name: '',
    },
  }),
  mounted() {
    this.getRefLager(0);
  },
  methods: {
    async getRefLager(skip = 0) {
      const uri = `${fixed.API_URL}/admin/get-ref-lager?skip=${skip}`;
      this.loading = true;
      try {
        const { data } = await axios.get(uri, { withCredentials: true });
        if (!data) {
          this.$toast.info('No articles to order');
        } else {
          this.products = data;
        }
      } catch (error) {
        this.$toast.error('can\'t fetch products');
      }
      this.loading = false;
    },
    async getKwikyFromSKUList(list = [], refStock) {
      if (!list.length || !refStock.articleId) {
        this.$toast.info('no Kwiky products for this item');
        return;
      }

      const skus = list.join(',');
      const uri = `${fixed.API_URL}/admin/kwiky-products-from-skus?p=${skus}`;

      this.loading = true;
      try {
        const { data } = await axios.get(uri, { withCredentials: true });
        if (!data || !data.length) {
          this.$toast.info('No articles to order');
        } else {
          this.kwikyProducts = data.sort((a, b) => a.name.localeCompare(b.name));
          this.selectedRefArticle.id = refStock.articleId;
          this.selectedRefArticle.name = refStock.name || 'No name';
          this.toggleKwiky();
        }
      } catch (error) {
        this.$toast.error('can\'t fetch Kwiky products');
      }
      this.loading = false;
    },
    async deleteRefStockArticle(id) {
      if (!id) return;

      const confirmed = confirm('Are you sure you want to permanently delete this article?'); // eslint-disable-line
      if (!confirmed) return;

      const uri = `${fixed.API_URL}/admin/delete-ref-lager-product/${id}`;
      this.loading = true;

      try {
        await axios.delete(uri, { withCredentials: true });
        await this.getRefLager(this.page);
        this.$toast.success('Article removed successfully');
      } catch (error) {
        this.$toast.error(`error while deleting ref article: ${error.message}`);
      }
      this.loading = false;
    },
    async orderKwikyArticle(sku, name) {
      if (!sku) return;

      // We're ordering as WORKSHOP with quantity 1 as default
      const meta = 'WORKSHOP';
      const qtt = 1;
      this.loading = true;

      try {
        await axios.post(`${fixed.API_URL}/admin/poland-order`, { sku, qtt, meta }, { withCredentials: true });
        this.selectedRefArticle.ordered = true;
        this.$toast.success(`${name || 'Article'} ordered successfully`);
      } catch (error) {
        if (error.response && error.response.status === 403) {
          this.$toast.warning('you\'re not authorised for that action ✋🏻');
        } else {
          this.$toast.error(`error while ordering Kwiky article: ${error.message}`);
        }
      }
      this.loading = false;
    },
    async setRefArticleAsOrdered() {
      if (!this.selectedRefArticle.id) return;

      this.loading = true;
      try {
        await axios.put(`${fixed.API_URL}/admin/set-ref-as-ordered/${this.selectedRefArticle.id}`, {}, { withCredentials: true });
        // if call was successful reset current selected article
        this.selectedRefArticle = { id: null, ordered: false, name: '' };
        // get the new list without the one just ordered
        await this.getRefLager(this.page);
        this.$toast.success('Ref article set as ordered and removed from the list');
      } catch (error) {
        this.$toast.error(`error while setting article as ordered: ${error.message}`);
      }
      this.loading = false;
    },
    nextPage() {
      this.page += 1;
      this.getRefLager(this.page);
    },
    prevPage() {
      if (!this.page) return;
      this.page -= 1;
      this.getRefLager(this.page);
    },
    toggleKwiky() {
      this.showKwiky = !this.showKwiky;
    },
    showProductImage(url) {
      this.productImage = url;
      this.$refs['image-modal'].show();
    },
    orderingDone() {
      if (this.selectedRefArticle.ordered) {
        this.setRefArticleAsOrdered();
      }

      this.toggleKwiky();
    },
    manufacturerFromCodes(codes = []) {
      for (let i = 0; i <= codes.length; i += 1) {
        if (codes[i].type === 'manufacturer') {
          return codes[i].code;
        }
      }

      return 'No manufacturer';
    },
    oemsFromCodes(codes = []) {
      const oems = [];
      codes.forEach((code) => {
        if (code?.type === 'oem') {
          oems.push(code.code);
        }
      });
      return oems.join(' ');
    },
  },
};
</script>
<style scoped>
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 10;
  display: flex;
  justify-content: center;
  //align-items: center;
}

.kwiky-products-box {
  margin-top: 90px;
  max-height: 85vh;
  overflow: auto;
}
</style>
